import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 100px;
`;

export const Title = styled.h1`
  font-size: 65px;
  font-family: Poppins-SemiBold;
  text-align: center;
  color: #1d1d1d;
`;

export const SubTitle = styled.p`
  font-size: 32px;
  font-family: Poppins-Light;
  text-align: center;
  color: #1d1d1d;
  width: 100%;
  margin: 0 auto;
`;

export const BackgroundImage = styled.img``;
